import { css } from 'styled-components'
import { Color, ColorShade, themeColor } from './palette'
import { transitions } from './utility'

export const linkReset = css`
  color: inherit;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    text-decoration: none;
  }
`

export const linkInline = css`
  color: ${themeColor(Color.primary)};
  text-decoration: none;

  &:hover,
  &:focus-visible {
    text-decoration: underline;
  }
`

export const link = css`
  ${linkReset};
  color: ${themeColor(Color.primary)};
  ${transitions(['color'])};

  &:hover,
  &:focus-visible {
    color: ${themeColor(Color.primary, ColorShade.semiSoft)};
  }
`

export const linkStrong = css`
  ${linkReset};
  color: ${themeColor(Color.primary, ColorShade.semiStrong)};
  ${transitions(['color'])};

  &:hover,
  &:focus-visible {
    color: ${themeColor(Color.primary, ColorShade.strong)};
  }
`

export const buttonReset = css`
  cursor: pointer;
  padding: 0;
  background-color: transparent;
  border: 0;
  ${transitions(['color', 'background-color', 'border-color', 'opacity'])};
  -webkit-tap-highlight-color: transparent;
  font-size: inherit;

  &:focus {
    outline: none;
  }

  &::-moz-focus-inner {
    border: 0 !important;
  }
`
